export function formatJsonToReadableText(obj, indent = '') {
    if (typeof obj !== 'object' || obj === null) {
        return `${indent}${String(obj)}`;
    }

    let result = '';

    for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const value = obj[key];

        if (Array.isArray(value)) {
            result += `${indent}${capitalize(key)}:\n`;
            value.forEach((item, idx) => {
                result += `${indent}  - ${formatJsonToReadableText(item, indent + '    ')}\n`;
            });
        } else if (typeof value === 'object' && value !== null) {
            result += `${indent}${capitalize(key)}:\n${formatJsonToReadableText(value, indent + '  ')}\n`;
        } else {
            result += `${indent}${capitalize(key)}: ${value}\n`;
        }
    }

    return result.trim();
}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}



export function prettyFormatObject(obj) {
    const result = [];

    for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        let value = obj[key];

        // Обрезка длинных строк
        if (typeof value === 'string') {
            value = value.trim();
            if (/^\d{4}-\d{2}-\d{2}T/.test(value)) {
                // Преобразование ISO-даты
                const date = new Date(value);
                if (!isNaN(date)) {
                    value = date.toLocaleString();
                }
            }
        }

        // Числа с экспонентой — нормализуем
        if (typeof value === 'number' && !Number.isInteger(value)) {
            value = parseFloat(value.toFixed(2));
        }

        result.push(`${formatLabel(key)}: ${value}`);
    }

    return result.join('\n');
}

// Преобразование ключей в читабельный формат
function formatLabel(str) {
    return str
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase -> space
        .replace(/\b\w/g, (l) => l.toUpperCase()); // первая буква каждого слова
}


export function transformToChartData(data) {
    const statusLabels = {
        15: 'В пути',
        22: 'Готово',
        1: 'На складе',
        // добавь другие статусы при необходимости
    };

    const colors = {
        15: ['#4caf50', '#66bb6a'],      // Completed
        10: ['#ff9800', '#ffb74d'],      // Pending
        5: ['#2196f3', '#64b5f6'],       // In Progress
    };

    // Группируем по статусу
    const grouped = {};

    for (const item of data) {
        const status = item.status;
        if (!grouped[status]) grouped[status] = 0;
        grouped[status] += item.countOrder;
    }

    const labels = [];
    const chartData = [];
    const backgroundColor = [];
    const hoverBackgroundColor = [];

    for (const [status, count] of Object.entries(grouped)) {
        const label = statusLabels[status] || `Status ${status}`;
        const [bg, hover] = colors[status] || ['#9e9e9e', '#bdbdbd'];
        labels.push(label);
        chartData.push(count);
        backgroundColor.push(bg);
        hoverBackgroundColor.push(hover);
    }

    return {
        labels,
        datasets: [
            {
                data: chartData,
                backgroundColor,
                hoverBackgroundColor,
            },
        ],
    };
}

export function getDiff(oldStr, newStr) {
    const oldData = JSON.parse(oldStr);
    const newData = JSON.parse(newStr);

    const diff = {};

    for (const key in newData) {
        if (JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])) {
            diff[key] = {
                old: oldData[key],
                new: newData[key],
            };
        }
    }

    return diff;
}



export async function getTrackStatus(trackingNumber) {
    try {
        const myHeaders = new Headers();
        myHeaders.append(
            "Cookie",
            "connect.sid=s%3AINrF21eiWqXFAf9h3AgcnIusqbjEaiP5.wkyHtixinOH5TKmsVZ9voBOa5TcoyQw7dr1Yac7QAnk"
        );

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };

        const url = `https://api.nomex.ibm.kg/track_status?token=${"Ghu87KJB87gkjgbB78"}&tracking_number=${trackingNumber}`;
        const response = await fetch(url, requestOptions);
        const result = await response.json();

        console.log(result);
        return result;
    } catch (error) {
        console.error("Ошибка при получении трек-статуса:", error);
        throw error;
    }
}

export const toNumber = (v) =>
    v === '' || v === null || v === undefined ? null : Number(v);
